import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { OutputSettingsBaseCard, OutputSettingsBaseCardProps } from "./OutputSettingsBaseCard";
import { FieldValidation } from "../useCreateWizard";
import { CustomFieldDefinition } from "../../../../models/Event";

interface StorageCardProps extends OutputSettingsBaseCardProps, WithTranslation {
    validation?: FieldValidation;
}

class StorageCardComponent extends OutputSettingsBaseCard<StorageCardProps> {
    protected getTitleTranslationKey(): string {
        return "cards.storage.title";
    }

    protected renderCardBody(): React.ReactNode {
        return this.renderGuestFieldOptions();
        /*
    This code allows to switch the certificate naming to guest_uuid
    const { outputSettings, selectedEvent } = this.props;
    return (
      <>
        <Form.Group className="mb-3">
          <Form.Label>Certificate File Naming Strategy</Form.Label>
          <div className="mt-2">
            <Form.Check 
              type="radio"
              id="naming-guest-uuid"
              key="naming-guest-uuid"
              name="certificateNaming"
              label="Create certificate with guest UUID"
              checked={outputSettings.certificateNaming === 'guest_uuid'}
              onChange={() => this.handleSettingChange('certificateNaming', 'guest_uuid')}
              className="mb-2"
            />
            <Form.Check 
              type="radio"
              id="naming-random-field"
              key="naming-random-field"
              name="certificateNaming"
              label="Create certificate with random name and set to field"
              checked={outputSettings.certificateNaming === 'guest_field'}
              onChange={() => this.handleSettingChange('certificateNaming', 'guest_field')}
              className="mb-2"
            />
          </div>
        </Form.Group>

        {this.renderGuestFieldOptions()}
      </>
    );
    */
    }

    private renderGuestFieldOptions(): React.ReactNode {
        const { outputSettings, selectedEvent } = this.props;

        if (outputSettings.documentNaming !== "guest_field" || !selectedEvent) {
            return null;
        }

        const customFields = selectedEvent.customFieldDefinitions
            ? selectedEvent.customFieldDefinitions
                  .filter((customField: CustomFieldDefinition) => customField.type === "TEXT")
                  .sort((a: CustomFieldDefinition, b: CustomFieldDefinition) => (a.sortIndex || 0) - (b.sortIndex || 0))
            : [];

        const { t } = this.props;

        return this.renderCustomFieldSelector({
            texts: {
                label: t("cards.storage.label"),
                description: t("cards.storage.fieldDescription"),
                noFieldsMessage: t("cards.storage.noFieldsMessage"),
            },
            customFields: customFields,
            selectedFieldId: outputSettings.customFieldDefinitionId,
            onFieldIdChange: (value) => this.handleSettingChange("customFieldDefinitionId", value),
            writeMode: {
                value: outputSettings.customFieldOverwrite,
                onChange: (value) => this.handleSettingChange("customFieldOverwrite", value),
            },
            validation: this.props.validation,
        });
    }
}

export const StorageCard = withTranslation("wizard")(StorageCardComponent);
